module.exports = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13,20 L0,7 L7,0 L20,13 L33,0 L40,7 L27,20 L40,33 L33,40 L20,27 L7,40 L0,33 L13,20 Z\" fill=\"#000000\" fill-rule=\"evenodd\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./assets/close.svg
 ** module id = 34
 ** module chunks = 0
 **/